import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { PageLayoutBaseComponent } from '../page-layout-base.component';
import { PDFDocuments } from 'src/app/types/PDFDocuments';
import { AppService } from 'src/app/app.service';
import { AdobePdfService } from 'src/app/services/adobe-pdf.service';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-public-comment',
  imports: [PdfViewerComponent],
  templateUrl: './public-comment.component.html',
  styleUrl: './public-comment.component.scss',
})
export class PublicCommentComponent
  extends PageLayoutBaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  pdfDocuments: PDFDocuments[] = [];
  trustedSurveyUrl: SafeResourceUrl = '';
  private surveyUrlSubscription: Subscription | undefined;

  constructor(
    protected override appService: AppService,
    private adobePdfService: AdobePdfService,
    private sanitizer: DomSanitizer
  ) {
    super(appService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getSurvey123URL();
    this.pdfDocuments = [
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Handout-09-24-2025.png',
        url: 'https://vmr-cdn.tdotoutreach.com/content/public-comment/Handout-09-24-2025.pdf',
        title: 'Handout',
      },
    ];
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.adobePdfService.embedMultiplePdfs(this.pdfDocuments);
    }, 100);
  }

  getSurvey123URL(): void {
    this.surveyUrlSubscription = this.appService
      .getSurvey123Url()
      .subscribe((surveyUrl) => {
        const trustedSurveyUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(surveyUrl);
        this.trustedSurveyUrl = trustedSurveyUrl;
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.surveyUrlSubscription) {
      this.surveyUrlSubscription.unsubscribe();
    }
  }
}
